module.exports = __webpack_public_path__ + "img/quality.0772878c.svg";